import PartnerPDPLandingPage from '@src/quince-site-landing/src/templates/partnerPDPLandingPage'

import { PageTemplateProps } from './page-templates.types'

export default function PartnerPDPPageTemplate({ pageData, isMobile }: PageTemplateProps) {
  const pageDataJson = pageData.context.pageDataJson
  return <PartnerPDPLandingPage pageData={pageDataJson} isMobile={isMobile} />
}
